import {
  GET_CATALOGS_MENU_SUCCESS,
  GET_CATALOGS_MENU_FAIL,
  SET_STATE_MENUCATALOGS,
} from "./actionTypes";

const INIT_STATE = {
  catalogs: [],
  error: {},
  total: 0,
  currentPage: 0,
  loading: false,
};

const menu = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CATALOGS_MENU_SUCCESS:
      return {
        ...state,
        catalogs: action.payload.catalogs,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_MENUCATALOGS:
      return { ...state, loading: action.payload }

    case GET_CATALOGS_MENU_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default menu;
